module.exports = __webpack_public_path__ + "static/img/ryba.d37dce87.webp";